const CarrierGoods = () => import('@/modules/Carrier/manager/CarrierGoodslist')
const CarrierConcernList = () => import('@/modules/Carrier/carrierconcern/CarrierConcernList')
const CarrierUpdateList = () => import('@/modules/Carrier/carrierupdate/PageCarrierUpdate')

export default [
  {
    path: '/carrier',
    name: 'carrierManager',
    component: CarrierGoods,
    meta: {
      title: '载体管理',
      isBlack: true
    },
  },
  {
    path: '/carrierconcern',
    name: 'carrierConcern',
    component: CarrierConcernList,
    meta: {
      title: '载体关注',
      isBlack: true
    },
  },
  {
    path: '/carrierUpdate',
    name: 'carrierUpdate',
    component: CarrierUpdateList,
    meta: {
      title: '载体最新动态',
      isBlack: true
    },
  },

]
